<style scoped>
  @import './otp-channel-selector.scss';
</style>
<script>

import Continue from '../lightbox/continue/continue.vue'
import { CONSTANT, AUTH_METHODS } from '@/utils/constant.js'
import sharedService from '@/utils/shared-service'
import requestBody from '@/orchestration/authSDK/request-parameter'
import traceService from '../shared/trace/trace-service'

export default {
  name: 'OtpChannelSelector',
  components: {
    Continue
  },
  props: {
    initiateAuthParams: {
      type: Object
    },
    authenticationMethods: {
      type: Array
    }
  },
  data () {
    return {
      CONSTANT: CONSTANT,
      selectedOtpMethod: '',
      otpMethods: [],
      error: '',
      supportedValidationChannels: []
    }
  },

  created () {
    this.displayOtpMethods()
  },

  methods: {
    displayOtpMethods () {
      this.otpMethods = []
      this.supportedValidationChannels = this.authenticationMethods.filter((channel) => channel.authenticationMethodType.includes('OTP'))
      if (this.supportedValidationChannels.length > 0) {
        this.supportedValidationChannels.forEach(validationChannel => {
          let authenticationMethodType = validationChannel.authenticationMethodType || ''
          if (authenticationMethodType.includes('EMAIL_OTP')) {
            this.otpMethods.push({ 'Email a code to': validationChannel.authenticationCredentialReference })
          } else if (authenticationMethodType.includes('SMS_OTP')) {
            this.otpMethods.push({ 'Text a code to': validationChannel.authenticationCredentialReference })
          }
        })
      }
      this.selectedOtpMethod = Object.values(this.otpMethods[0])[0]
    },

    async resendOtp () {
      await this.$store.commit('lightBoxloaderOn', false)
      this.initiateAuthenticate()
    },

    async initiateAuthenticate () {
      this.$store.commit('loaderOn', true)
      const network = 'mastercard'
      const authenticationMethod = this.supportedValidationChannels.filter((channel) => channel.authenticationCredentialReference === this.selectedOtpMethod)
      const request = this.initiateAuthParams.request.authenticateRequest
      const srcDigitalCardId = request.accountReference.srcDigitalCardId
      const serviceId = request.serviceId
      const srcCorrelationId = request.srcCorrelationId
      const authenticationReason = request.authenticationContext.authenticationReasons

      let reqParams = requestBody[AUTH_METHODS.B2B_INITIATE_AUTHENTICATE](
        authenticationMethod[0],
        authenticationReason[0],
        srcCorrelationId,
        srcDigitalCardId,
        serviceId
      )
      try {
        let response = await sharedService.getB2BAuthenticateApiResponse(reqParams)
        traceService.updateCallTraces(network, response.callTraces, true)
        this.$store.commit('loaderOn', false)
        this.$emit('resendOTP', reqParams, response)
        return response
      } catch (err) {
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(network, errorLog, false)
        this.$store.commit('loaderOn', false)
        this.error = err.response.data.message
        return errorLog
      }
    }
  }
}
</script>
<template>
  <div class="mb-5 otp-methods">
    <div
      v-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <h4 class="text-center mt-4 font-weight-bold">
      {{ $t ('label.continueAnotherWay') }}
    </h4>
    <div class="main-wrapper mt-4 mb-5">
      <div class="main-container">
        <div
          v-for="(item, index) in otpMethods"
          :key="index"
          :value="Object.values(item).toString()"
          class="border-bottom pl-3 row method-row"
        >
          <label class="radio text-break radio-align">
            <span class="ml-1">{{ Object.keys(item).toString() }}</span>
            <div class="ml-1">{{ Object.values(item).toString() }}</div>
            <input
              :id="'otpMethod-' + index"
              v-model="selectedOtpMethod"
              :value="Object.values(item).toString()"
              class="d-inline float-left"
              type="radio"
            >
            <div class="check d-md-inline otp-radio" />
          </label>
        </div>
      </div>
    </div>
    <div class="text-center">
      <continue
        @submit="resendOtp()"
      />
    </div>
  </div>
</template>
